"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroup = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Avatar_1 = require("./Avatar");
const ButtonModal_1 = require("../ButtonModal");
const Css_1 = require("../../Css");
function AvatarGroup(props) {
    const { avatars, size = "md" } = props;
    // If there are 8 or fewer avatars, show them all. Otherwise, show the first 7 and a menu with the rest.
    const maxVisibleAvatars = avatars.length <= 8 ? 8 : 7;
    const visibleAvatars = avatars.slice(0, maxVisibleAvatars);
    const menuAvatars = avatars.slice(maxVisibleAvatars);
    return ((0, jsx_runtime_1.jsxs)("div", { css: Css_1.Css.df.aic.gap1.xsSb.$, children: [(0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.df.aic.$, children: visibleAvatars.map((avatar, idx) => {
                    var _a;
                    return ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.br100.ba.bcWhite
                            .add("borderWidth", "3px")
                            .if(idx > 0)
                            .mlPx(-1 * sizeToOverlap[size]).$, children: (0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { src: avatar.src, name: avatar.name, size: size }) }, (_a = avatar.src) !== null && _a !== void 0 ? _a : idx));
                }) }), menuAvatars.length > 0 && ((0, jsx_runtime_1.jsx)(ButtonModal_1.ButtonModal, { trigger: { label: `+ ${menuAvatars.length} more`, variant: "text" }, hideEndAdornment: true, content: (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.df.fdc.gap1.mPx(-12).$, children: menuAvatars.map((a, idx) => {
                        var _a;
                        return ((0, jsx_runtime_1.jsx)(Avatar_1.Avatar, { src: a.src, name: a.name, showName: true, size: "md" }, (_a = a.src) !== null && _a !== void 0 ? _a : idx));
                    }) }) }))] }));
}
exports.AvatarGroup = AvatarGroup;
const sizeToOverlap = {
    sm: 9,
    md: 9,
    lg: 15,
    xl: 22,
};
